import { createTheme } from "@material-ui/core/styles";

const theme = createTheme({
  palette: {
    primary: {
      light: "#223043",
      main: "#223043",
      dark: "#223043",
      contrastText: "#223043",
    },
    secondary: {
      light: "#e22a2e",
      main: "#ad171a",
      dark: "#730f11",
      contrastText: "#fff",
    },
  },
});

export default theme;
